'use client'
import React, { createContext } from 'react'

import { ModalProperties } from './entities'
import useModalContextValue from './useModalContextValue'

const ModalContext = createContext<ModalProperties | null>(null)

export const ModalProvider = ({ ...props }) => {
  const value = useModalContextValue()

  return (
    <ModalContext.Provider value={value}>
      {props.children}
    </ModalContext.Provider>
  )
}

export const useModalContext = () => {
  const context = React.useContext(ModalContext)
  if (!context) {
    throw new Error('useModal: No context')
  }
  return context
}
